import { render, staticRenderFns } from "./HotelHighlightGroupphotoList.vue?vue&type=template&id=65294752&"
import script from "./HotelHighlightGroupphotoList.vue?vue&type=script&lang=js&"
export * from "./HotelHighlightGroupphotoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports